import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faTelegram,
} from '@fortawesome/free-brands-svg-icons';

export function ShareURL(props: { url: string; excerpt?: string }) {
  return (
    <div className={[`flex`, `items-center`, `gap-x-4`, `my-12`].join(` `)}>
      {` `}
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${props.url}`}
        target="_blank"
        rel="noreferrer"
        className={[
          `w-[3.5em]`,
          `h-[3.5em]`,
          `flex`,
          `justify-center`,
          `items-center`,
          `bg-white`,
          `rounded-full`,
          `shadow`,
          `hover:shadow-lg`,
          `transition-shadow`,
        ].join(` `)}
      >
        <FontAwesomeIcon icon={faFacebookF} fontSize="1.5em" />
      </a>

      <a
        href={`https://twitter.com/intent/tweet?url=${props.url}&text=${
          props.excerpt || ``
        }`}
        target="_blank"
        rel="noreferrer"
        className={[
          `w-[3.5em]`,
          `h-[3.5em]`,
          `flex`,
          `justify-center`,
          `items-center`,
          `bg-white`,
          `rounded-full`,
          `shadow`,
          `hover:shadow-lg`,
          `transition-shadow`,
        ].join(` `)}
      >
        <FontAwesomeIcon icon={faTwitter} fontSize="1.5em" />
      </a>

      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${props.url}`}
        target="_blank"
        rel="noreferrer"
        className={[
          `w-[3.5em]`,
          `h-[3.5em]`,
          `flex`,
          `justify-center`,
          `items-center`,
          `bg-white`,
          `rounded-full`,
          `shadow`,
          `hover:shadow-lg`,
          `transition-shadow`,
        ].join(` `)}
      >
        <FontAwesomeIcon icon={faLinkedinIn} fontSize="1.5em" />
      </a>

      <a
        href={`tg://msg_url?url=${props.url}&text=${props.excerpt?.substring(
          0,
          200,
        )}`}
        rel="noreferrer"
        className={[
          `w-[3.5em]`,
          `h-[3.5em]`,
          `flex`,
          `justify-center`,
          `items-center`,
          `bg-white`,
          `rounded-full`,
          `shadow`,
          `hover:shadow-lg`,
          `transition-shadow`,
        ].join(` `)}
      >
        <FontAwesomeIcon icon={faTelegram} fontSize="1.5em" />
      </a>
    </div>
  );
}
